import * as React from 'react';

const SvgChevronDownOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z", fill: "currentColor" })));

export { SvgChevronDownOutline as default };
